export default __webpack_public_path__ + "static/media/top-banner.891dec7d.png";